import cookieModel from './cookie';

export default {
  logout: function (router) {
    cookieModel.deleteAllNamedCookies('ticketlab_access');
    router.replace({
      name: 'Login'
    });
  },
  isLoggedIn: function () {
    return !(
      !cookieModel.getCookie("ticketlab_access") ||
      cookieModel.getCookie("ticketlab_access") === ''
    );
  },
};
